import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { NewsTypeReferenceModel } from "../../models/reference-model/reference-general-model/news-type-reference.model";

@Injectable({
    providedIn: 'root'
})
export class NewsTypeReferenceService extends ApiServiceBase {
    private readonly REFERENCE_PATH = '/system/newstypereferences';

    constructor(
        httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getAll(): Observable<NewsTypeReferenceModel[]> {
        return this.httpGet<NewsTypeReferenceModel[]>(this.REFERENCE_PATH, null)
            .pipe(
                map(res => res.body)
            )
    }
}